import { render } from "./Person.vue?vue&type=template&id=1d844b08"
const script = {}
script.render = render

export default script